import { render, staticRenderFns } from "./ProfilePreviewComponent.vue?vue&type=template&id=8427cb3c&scoped=true&class=boxplacement&"
import script from "./ProfilePreviewComponent.vue?vue&type=script&lang=js&"
export * from "./ProfilePreviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePreviewComponent.vue?vue&type=style&index=0&id=8427cb3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8427cb3c",
  null
  
)

export default component.exports